module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre4"
  }, [_vm._v("'s ist so ein stiller, heil'ger Tag")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("'s ist so ein stiller, heil'ger Tag,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nman hört der Zeiten Flügelschlag.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Der erste Schnee, mit leiser Hand,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndeckt Anger zu und Heideland;")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("er hüllt in lichten Totenschrein"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndes Herbstes düstre Trümmer ein.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Wär' für der Seele Trümmerfeld"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndoch auch ein solcher Schrein bestellt! "), _c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page25",
      "title": "wedi/Konmax"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a30686d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0010.vue
// module id = 84
// module chunks = 0